import React, { Context, createContext } from 'react';
import { useDispatch } from 'react-redux';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Resources from './Resources';
import { OpenAPIV3_1 as OpenAPI } from "openapi-types";
import _, { Dictionary } from 'lodash';


export interface DocumentationProps {
    json: OpenAPI.Document;
}

export const DocContext: Context<OpenAPI.Document | null> = createContext<OpenAPI.Document | null>(null);

const App: React.FC<DocumentationProps> = ({ json }) => {
    const dispatch = useDispatch();

    return (
        <DocContext.Provider value={json}>
            <Box>
                <Typography sx={{ mb: 1 }}>{json.info.title} {json.info.version}</Typography>
                <Resources json={json} />
            </Box>
        </DocContext.Provider>
    );
};

export default App;
